export const EmailDomain = ['naver.com', 'gmail.com', 'hanmail.com', 'nate.com'];
